// extracted by mini-css-extract-plugin
export default {"add-to-folder":"AddToFolder_add-to-folder__L8TCv"};